import { useQuery } from '@tanstack/react-query';
import type { Database } from '@pirouette/db';
import { supabase } from '@/lib/supabase';

export interface LeadConversionReportRow {
  lead_status: Database['public']['Enums']['lead_status'];
  source: string;
  lead_count: number;
  converted_count: number;
}

export interface ProgramEnrollmentReportRow {
  program_type: Database['public']['Enums']['program_type'];
  active_enrollment_count: number;
  class_count: number;
  total_capacity: number;
}

export interface PrivateLessonUtilizationReportRow {
  program_type: Database['public']['Enums']['program_type'];
  program_name: string;
  location_name: string;
  instructor_name: string;
  lesson_count: number;
  active_enrollment_count: number;
  total_capacity: number;
}

export interface CostumeDeadlinesReportRow {
  production_name: string;
  package_name: string;
  due_date: string | null;
  assignment_count: number;
  incomplete_count: number;
}

export interface RecitalPackageFulfillmentReportRow {
  item_name: string;
  item_status: Database['public']['Enums']['package_item_status'];
  assignment_count: number;
}

export function useLeadConversionReport() {
  return useQuery({
    queryKey: ['reports', 'lead-conversion'],
    queryFn: async (): Promise<LeadConversionReportRow[]> => {
      const { data, error } = await supabase.rpc('report_lead_conversion');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useProgramEnrollmentReport() {
  return useQuery({
    queryKey: ['reports', 'program-enrollment'],
    queryFn: async (): Promise<ProgramEnrollmentReportRow[]> => {
      const { data, error } = await supabase.rpc('report_program_enrollment');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function usePrivateLessonUtilizationReport() {
  return useQuery({
    queryKey: ['reports', 'private-lesson-utilization'],
    queryFn: async (): Promise<PrivateLessonUtilizationReportRow[]> => {
      const { data, error } = await supabase.rpc('report_private_lesson_utilization');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useCostumeDeadlinesReport() {
  return useQuery({
    queryKey: ['reports', 'costume-deadlines'],
    queryFn: async (): Promise<CostumeDeadlinesReportRow[]> => {
      const { data, error } = await supabase.rpc('report_costume_deadlines');
      if (error) throw error;
      return data ?? [];
    },
  });
}

export function useRecitalPackageFulfillmentReport() {
  return useQuery({
    queryKey: ['reports', 'recital-package-fulfillment'],
    queryFn: async (): Promise<RecitalPackageFulfillmentReportRow[]> => {
      const { data, error } = await supabase.rpc('report_recital_package_fulfillment');
      if (error) throw error;
      return data ?? [];
    },
  });
}
